import React from 'react';
import PropTypes from 'prop-types';

const SearchItem: React.FC<Props> = (props) => {
  const {
    label,
    item,
    icon,
    clickable,
    customClassName,
    onItemClick,
    isHistory
  } = props;
  const handleClick = () => {
    if (clickable && typeof onItemClick === 'function') {
      onItemClick({ ...item, isHistory });
    }
  };
  return (
    <div
      className={`mls-item ${
        clickable ? 'mls-item--clickable' : ''
      } ${customClassName}`}
      onClick={handleClick}
    >
      <div className="mls-item--content">
        {label}
        {icon}
      </div>
    </div>
  );
};

const propTypes = {
  label: PropTypes.string,
  item: PropTypes.any,
  icon: PropTypes.element,
  clickable: PropTypes.bool,
  customClassName: PropTypes.string,
  onItemClick: PropTypes.func,
  isHistory: PropTypes.bool
};

type Props = PropTypes.InferProps<typeof propTypes>;

SearchItem.defaultProps = {
  label: '',
  item: null,
  icon: null,
  clickable: true,
  customClassName: '',
  onItemClick: () => {},
  isHistory: false
};

export default SearchItem;
